import React, { Component } from 'react'
import { Trans } from '@lingui/macro'
import { connect } from 'react-redux'

import LineSeparator from '../../../../components/LineSeparator'
import Row from '../../../../components/Row'
import { Typography, TextInput } from 'components'
import RadioToggle from '../../../../components/RadioToggle'
import Toggle from '../../../../components/Toggle'

import { getProducts, addProductsData } from '../../../../redux/actions'
import { getPlans } from '../../../../redux/actions/plansActions'
import { currencyNormalization } from '../../../../utils/orderHandlers'

class ProductsData extends Component {

  initialProducts = this.props.personProductsData.map(product => {
    product.active = true
    return product
  });

  state = {
    canSave: true,
    products: this.props.isEdit ? this.initialProducts : [],
    isBlockChecked: false,
  }

  componentDidMount() {
    this.props.onGetProducts(this.props.role)
    this.props.onGetPlans({
      profile_role: this.props.role,
      ...(this.props.role === 'PSIQ' && { is_particular: false })
    })
    this.checkRequiredFields()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.products !== this.state.products) {
      this.checkRequiredFields()
    }
  }

  handleToggleProduct = (appointmentId, productId) => {
    let { products } = this.state

    const productIndex = products.findIndex(product => product.product_id === productId && product.active === true)

    if (productIndex >= 0) {
      // Inativar produto
      if (this.props.isEdit) {
        products[productIndex].active = false
      } else {
        products = products.filter(product => product.product_id !== productId)
      }
    } else {
      const disabledIndex = products.findIndex(product => product.product_id === productId && product.active === false)

      if (disabledIndex >= 0) {
        // Ativar produto
        products[disabledIndex].active = true
      } else {
        // Adicionar produto
        const priceDefault = products[0]?.price || '1.00'
        products.push({
          active: true,
          appointment_id: appointmentId,
          product_id: productId,
          price: priceDefault
        })
      }
    }

    this.setState({ products })
    this.checkRequiredFields()
  }

  handleCleanProducts = () => {
    let allProducts = [...this.state.products]

    let cleanProducts = []
    for (let i = 0; i < allProducts.length; i++) {
      const product = allProducts[i]
      if (product !== {}) {
        cleanProducts.push(product)
      }
    }

    this.setState({ products: cleanProducts })
  }

  handleCheckAppointment = (productId) => {
    const { products } = this.state
    return products.find(product => product.product_id === productId && product.active) ? true : false
  }

  handleCheckPlan = (appointmentId, planId, productId) => {
    let products = [...this.state.products]
    const product = products.find(product => product.appointment_id === appointmentId && product.product_id === productId)
    const hasPlan = product.plans ?
      product.plans.find(plan => plan.partner_plan_id === planId) !== undefined ?
        true : false : false
    return hasPlan
  }

  handlePlanSelection = (planId, appointmentId, productId) => {
    let products = [...this.state.products]
    const targetProduct = products.find(product => product.product_id === productId)
    const plans = targetProduct.plans ?
      [...targetProduct.plans] : []
    let newPlans = []

    const hasPlan = plans.find(plan => plan.partner_plan_id === planId) ? true : false

    /**
     * If the plan exists on the plan Array in
     * the choosen appointment, the array will be
     * rebuilt without the targetPlan
     * 
     * If not, the plan will be added to the Array
     */

    if (hasPlan) {
      for (let i = 0; i < plans.length; i++) {
        const actualPlan = plans[i]

        if (actualPlan.partner_plan_id !== planId) {
          newPlans.push(actualPlan)
        }
      }
    } else {
      const newProduct = { partner_plan_id: planId }
      newPlans = [
        ...plans,
        newProduct,
      ]
    }

    this.handleUpdateTargetAppointment(productId, { 'plans': newPlans })

  }

  handlePriceInput = (e, productId) => {
    e.preventDefault()
    let inputValue = e.target.value

    if (new RegExp(/^[0-9]*,[0-9]*$/g).test(inputValue) ||
      new RegExp(/^[0-9]*$/g).test(inputValue)) {
      let formatedValue = currencyNormalization(inputValue)

      // this.handleUpdateTargetAppointment(productId, { "price": formatedValue });

      // NOTA: definindo o mesmo preço para os 2 produtos, pois o
      // segundo é Bradesco 30 min e não deve ter preço editado/informado.
      let updatedProducts = this.state.products.map(product => {
        product.price = formatedValue
        return product
      })
      this.setState({ products: updatedProducts })


      this.checkRequiredFields()
    }
  }

  handleCheckPrice = (productId) => {
    let products = [...this.state.products]
    const targetProduct = products.find(product => product.product_id === productId)
    return targetProduct.price ? targetProduct.price : ''
  }

  handleUpdateTargetAppointment = (productId, newData) => {
    let { products } = this.state

    let targetProductIndex = products.findIndex(product => product.product_id === productId)
    let targetProduct = products[targetProductIndex]

    let updatedProduct = {
      ...targetProduct,
      ...newData,
    }

    products[targetProductIndex] = updatedProduct

    this.setState({ products })

    this.checkRequiredFields()
  }

  checkRequiredFields = () => {
    let filedProducts = [...this.state.products]
    let isBlockChecked = filedProducts.length

    let finalProducts = filedProducts.map(product => {
      if (
        product.active &&
        (
          product.price === undefined ||
          product.price === null ||
          product.price === '' ||
          product.plans === undefined ||
          product.plans === null ||
          product.plans.length === 0
        )
      ) {
        isBlockChecked--
      }

      if (product.active === false) {
        product.plans = []
      }

      return product
    })

    const isReady = isBlockChecked === finalProducts.length

    this.setState({
      canSave: isReady,
      isBlockChecked: isReady
    })

    this.props.onAddProductsData(isBlockChecked, isReady, { products: finalProducts })

    return isBlockChecked
  }

  render() {
    return (
      <div className="RegisterBlock__ProductsData">
        <Row padding=" 0 0 2rem 0" direction="column">
          <Typography
            Tag="h2"
            align="mcenter-dleft">
            <Trans>
              Produtos
            </Trans>
          </Typography>
          <Typography
            italic
            Tag="h2"
            align="mcenter-dleft"
            color='grey-ten'>
            <Trans>
              Ative pelo menos um produto
            </Trans>
          </Typography>
        </Row>
        <Row>
          {
            /* PRODUCTS FORMS */
            this.props.products.map((product, index) => {
              return product.appointments.map(appointment => {
                return (
                  <Row className="RegisterBlock__ProductsData__product"
                    key={appointment.code}>
                    <div className="RegisterBlock__ProductsData__product__heading">
                      <div className="RegisterBlock__ProductsData__product__heading__fixed">
                        <div className="RegisterBlock__ProductsData__product__heading__fixed__title">
                          <Typography bold>
                            {appointment.name}
                          </Typography>
                          <Typography color="grey-ten">
                            {product.product_general.duration} <Trans>minutos</Trans>
                          </Typography>
                        </div>
                        <div className="RegisterBlock__ProductsData__product__heading__fixed__toggle">
                          <Toggle
                            isToggled={this.handleCheckAppointment(product.id)}
                            onToggledSwitch={(value) => this.handleToggleProduct(value, product.id)}
                            toggleId={`toggle-${appointment.code}`}
                            value={appointment.id}
                          />
                        </div>
                      </div>
                      {
                        // NOTA: mostrar o campo de preço somente para primeiro produto,
                        // pois o segundo é Bradesco 30 min e não deve ter preço definido.
                        this.handleCheckAppointment(product.id) && index === 0 && (
                          <div className="RegisterBlock__ProductsData__product__heading__price">
                            <Typography>
                              <Trans>
                                Valor da consulta
                              </Trans>
                            </Typography>
                            <TextInput
                              placeholder="R$ *"
                              required={true}
                              name={'document-{product.id}'}
                              inputHeight='4.8rem'
                              onInputChange={(e) => this.handlePriceInput(e, product.id)}
                              value={this.handleCheckPrice(product.id)}
                            />
                          </div>
                        )
                      }
                    </div>
                    {
                      this.handleCheckAppointment(product.id) && (
                        <div className="RegisterBlock__ProductsData__product__heading__plans">
                          <Typography className="RegisterBlock__ProductsData__product__heading__plans__title">
                            <Trans>Tipos de plano atendidos:</Trans>
                          </Typography>
                          {
                            this.props.plans.map(plan => (
                              <RadioToggle key={plan.id}
                                onClickRadioToggle={() => this.handlePlanSelection(plan.id, appointment.id, product.id)}
                                selected={this.handleCheckPlan(appointment.id, plan.id, product.id)}
                                title={`${plan.plan_group.name || ''} ${plan.name}`}
                                value={plan.id}
                              />
                            ))
                          }
                        </div>
                      )
                    }
                    <LineSeparator />
                  </Row>
                )
              })
            })
          }
        </Row>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    isEdit: state.registerBlocks.isEdit,
    personProductsData: state.registerBlocks.blocksData.productsData.products,
    products: state.products.products,
    plans: state.plans.plans,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onGetPlans: (params) => (dispatch(getPlans(params))),
    onGetProducts: (role) => (dispatch(getProducts(role))),
    onAddProductsData: (isBlockChecked, canSave, fields) => (dispatch(addProductsData(isBlockChecked, canSave, fields))),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductsData)